export default {
    name: 'iframe-report',
    displayName: '专利视图',
    tabIndex: 999, // 确保在菜单中靠后显示
    exclusiveRoutePath: '/iframe-report',
    fullView: true,
    getComponent: () => import('./IframeEntry.vue'),
}; 